import styled from 'styled-components';
  
  
export const Buttons = styled.div`
   position: fixed; 
   width: 100%;
   left: 90%;
   bottom: 60px;
   height: 20px;
   font-size: 2rem;
   z-index: 1;
   cursor: pointer;
   color: green;
`